import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import React from 'react';
import styled from 'styled-components';
var StatusWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  color: ", ";\n  font-size: ", ";\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])), function (props) {
  return props.type === 'secondary' ? 'normal' : 'bold';
}, function (props) {
  return props.type === 'secondary' ? props.theme.colors.darkGrey : props.theme.colors.dark;
}, function (props) {
  return props.type === 'secondary' ? props.theme.fontSizes.small : props.theme.fontSizes.medium;
});
var StatusBullet = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-right: 0.5rem;\n  font-size: 2rem;\n  line-height: 0;\n"])), function (props) {
  return props.theme.colors[props.colorScheme];
});

function Status(_ref) {
  var children = _ref.children,
      _ref$colorScheme = _ref.colorScheme,
      colorScheme = _ref$colorScheme === void 0 ? 'primary' : _ref$colorScheme,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type;
  return /*#__PURE__*/React.createElement(StatusWrapper, {
    type: type
  }, /*#__PURE__*/React.createElement(StatusBullet, {
    colorScheme: colorScheme
  }, "\u2022"), children);
}

export default Status;